
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import Block from './Block.vue'

// components
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import type { Standard2025TariffsMappedTariff } from '@/core/types/billing.types'

export default defineComponent({
    components: { Block, Loader, TheButton },
    props: {
        zoneId: {
            type: Number,
            default: 1
        },
        autoTariffs: {
            type: Array as PropType<Array<Standard2025TariffsMappedTariff>>,
            default: () => []
        },
        aviaTariffs: {
            type: Array as PropType<Array<Standard2025TariffsMappedTariff>>,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['refresh'],
    setup(props, { emit }) {
        const onRefresh = () => {
            if (props.loading) return
            emit('refresh')
        }

        return {
            onRefresh
        }
    }
})
